export const SUPPORTED_LANGUAGES = {
  en: {
    flagIcon: "gb-flag",
    language: "en",
    title: "English",
  },
  fr: {
    flagIcon: "fr-flag",
    language: "fr",
    title: "Français",
  },
  it: {
    flagIcon: "it-flag",
    language: "it",
    title: "Italiano",
  },
};
